import { useNavigate } from "react-router-dom";
import { useAtomValue } from "jotai";
import { isBackstageUserAtom } from "../../atoms/userAtom";
import { BackstageHeader } from "../common/backstageHeader";

interface NoticesHeaderProps {
  title: string;
  onClose?: () => void;
}

export function NoticesHeader({ title, onClose }: NoticesHeaderProps) {
  const navigate = useNavigate();
  const isBackstageUser = useAtomValue(isBackstageUserAtom);

  const onCloseClick = () => {
    if (onClose) {
      onClose();
    } else {
      navigate(-1);
    }
  };

  return isBackstageUser ? (
    <BackstageHeader title={title} />
  ) : (
    <div className="navbar bg-base-100 drop-shadow">
      <div className={"navbar-start"}></div>
      <div className={"navbar-center text-xl"}>{title}</div>
      <div className={"navbar-end"}>
        <button
          onClick={onCloseClick}
          className={
            "btn btn-ghost btn-sm p-0 w-8 h-8 flex items-center justify-center text-xl"
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18 18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
